import { ExportOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar as AvatarAntd, Button, Menu, Row as RowAntd } from 'antd';
import styled from 'styled-components';

export const ContainerGreetingUser = styled(RowAntd)`
  right: 30px;
  position: absolute;
  margin-top: 5px;
  margin-bottom: 5px;
`;

export const AvatarGreetingUser = styled(AvatarAntd)`
  width: 40px;
  height: 40px;
  background: #090e38;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: white;
  font-weight: bold;
  cursor: pointer;
`;

export const NameGreetingUser = styled.p`
  display: block;
  padding: 0;
  margin: 0;
  color: #000000;
  font-size: 15px;
  text-align: right;
  padding-right: 10px;
  font-weight: bold;
`;

export const NameGreetingImpersonatedUser = styled.p`
  display: block;
  padding: 0;
  margin: 0;
  color: #000000;
  font-size: 15px;
  text-align: right;
  padding-right: 10px;
`;

export const ColDescription = styled.div`
  line-height: initial;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const CustomButton = styled(Button)`
  color: #24a95d;
  font-weight: bold;
  width: 100%;
  text-align: left;

  &:hover {
    color: #197c44;
  }
`;

export const ExportOutlinedCustom = styled(ExportOutlined)`
  color: #0d3549;
`;

export const UserOutlinedCustom = styled(UserOutlined)`
  color: #0d3549;
`;

export const MenuCustom = styled(Menu)`
  width: 226px;
`;
